<div class="bl-padding-top--24 bl-padding-bottom--40 bl-padding-x--16 bl-padding-x-sm--24">
  <div class="bl-max-width--tablet-width bl-margin-x--auto">
    @if (!state().loading) {
    <section class="prefill-verification-container bl-width--100" aria-labelledby="prefill-heading">
      <div
        class="bl-max-width--tablet-width bl-margin-x--auto bl-display--flex bl-flex-direction--column bl-gap--24 bl-align-items--center bl-text-align--center"
        [class.error]="state().error"
        [class.success]="state().success"
        [attr.aria-live]="state().error ? 'assertive' : 'polite'"
      >
        <h2 id="prefill-heading" class="bl-text-style--display-3 bl-margin--0">
          {{ (state().error ? 'prefillVerification/mobileHeaderFailure' : 'prefillVerification/mobileHeader') | dictionary }}
        </h2>
        <p class="bl-text-style--default-text-1 bl-margin--0">
          {{ (state().error ? 'prefillVerification/mobileHeaderFailure2' : 'prefillVerification/mobileHeader2') | dictionary }}
        </p>
        <button type="button" class="bl-button bl-width--100" (click)="closeTab()">
          {{ 'prefillVerification/closeTab' | dictionary }}
        </button>
      </div>
    </section>
    }
  </div>
</div>
